<template>
  <slot name="header">
    <Demo color="red" height="30px" name="header" />
  </slot>

  <Container class="bg-surface-default-low pb-18 md:pb-48">
    <slot name="breadcrumb">
      <Demo color="blue" height="60px" name="breadcrumb" />
    </slot>

    <slot v-if="isOutOfStock" name="out-of-stock">
      <Demo color="green" height="60px" name="out-of-stock" />
    </slot>

    <section
      v-if="!isOutOfStock"
      class="mt-12 flex flex-col flex-wrap md:mt-32 md:flex-row md:flex-nowrap md:justify-evenly"
    >
      <div
        class="relative ml-0 mr-auto w-full max-w-full grow md:w-1/2 md:max-w-[min(33.33%,416px)] lg:max-w-[min(50%,560px)]"
      >
        <slot name="product-visuals">
          <Demo color="green" height="60px" name="ProductVisuals" />
        </slot>
      </div>
      <TheMainContent
        class="w-full max-w-full grow px-24 md:w-2/3 md:basis-2/3 lg:w-1/2 lg:basis-1/2 lg:pe-0 lg:ps-64"
      >
        <slot name="product-aside-content">
          <Demo color="pink" height="60px" name="ProductInformation" />
        </slot>
      </TheMainContent>
    </section>
  </Container>

  <RevContainer class="mb-32 [&>*]:space-y-32">
    <slot name="content">
      <Demo color="purple" height="60px" name="content" />
    </slot>
  </RevContainer>

  <ClientOnly>
    <slot name="modals" />
  </ClientOnly>
</template>

<script setup lang="ts">
import type { VNode } from 'vue'

import { RevContainer } from '@ds/components/Container'

import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'
import Container from '~/scopes/product-core/components/presentationals/Container/Container.vue'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'

import Demo from './components/Demo.vue'

defineSlots<{
  header: () => VNode
  breadcrumb: () => VNode
  ['out-of-stock']: () => VNode
  ['product-visuals']: () => VNode
  ['product-aside-content']: () => VNode
  content: () => VNode
  modals: () => VNode
}>()

const { isOutOfStock } = useFetchPickers()
</script>
